import { useState } from 'react';
import { addCategoriesTasks, editCategoriesTasks } from './api'
import '../styles/edit-form.scss';
import {
    TextField,
    Button,
    IconButton,
    FormGroup,
} from '@mui/material';
import { Close } from '@mui/icons-material';

export function CategoriesTasksEditForm(props) {
    const { closeEditForm, category } = props;
    const [name, setName] = useState(category.name);
    const [bitrix_code, setBitrixId] = useState(category.bitrix_code);
    const [default_volume, setDefaultVolume] = useState(category.default_volume);

    const addCategoryButtonClick = () => {
        !category.id
            ? addCategoriesTasks({
                name: name,
                bitrix_code: bitrix_code,
                default_volume: default_volume
            }).then(_ => closeEditForm(true))
            : editCategoriesTasks({
                id: category.id,
                name: name,
                bitrix_code: bitrix_code,
                default_volume: default_volume
            }).then(_ => closeEditForm(true));
    };

    const closeForm = () => {
        closeEditForm(false);
    };

    return (
        <div className="edit-form">
            <div className='edit-form__window'>
                <FormGroup>
                    <TextField className='input' label="Наименование" variant="standard" value={name} onChange={(event) => setName(event.target.value)} />
                    <TextField className='input' label="Id Битрикс" variant="standard" value={bitrix_code} onChange={(event) => setBitrixId(event.target.value)} />
                    <TextField className='input' label="Объем по умолчанию" variant="standard" value={default_volume} onChange={(event) => setDefaultVolume(event.target.value)} />
                    <Button variant="contained" id='submit-button' onClick={addCategoryButtonClick}>{category.id ? 'Изменить' : 'Добавить'}</Button>
                </FormGroup>
                <IconButton id='close-button' onClick={closeForm}>
                    <Close />
                </IconButton>
            </div>
        </div>
    );
}